/*
 * @Description: 营销效果数据弹窗
 * @Author: hujingyang
 * @LastEditors: yang chenglin
 */

import React, { useEffect, useState } from 'react';
import { Balloon, Button, Icon, Message, Table } from '@alifd/next';
import style from './index.module.scss';
import LzPagination from '@/components/common/LzPagination';
import utils from '@/common/utils';
import { store } from '@ice/stark-data';
import { Servlets } from '@/service';
import LzMsg from '@/components/common/LzMessage';
import moment from 'moment';

/**
 * 营销效果 页面
 * @param props object
 */
const Dialog_MarketingEffect_content = (props: any): JSX.Element => {
  const [params, setParams] = useState({ id: '', name: '' });// 父页面传递的数据
  const [dataSource, setDataSource] = useState([{}]);
  const [isLoadingForList, setLoadingForList] = useState(false);// 是否正在加载列表数据
  const [coreData, setCoreData] = useState(
    {
      totalSum: 0,
      totalPaymentNum: 0,
      oderConversionRate: 0,
      ROI: 0,
      perCapitaPaymentNum: 0,
      ordAmount: 0,
      ordPins: 0,
      truePeopleSentNum: 0,
    },
  );// 页面核心数据统计
  // 设置核心数据布局
  const coreDataLayoutSetting = {
    totalSum: { key: 'totalSum', text: '总付款金额', prompt: '统计时间内对该店铺商品付款的订单金额（有支付就算，不排除取消订单）', background: '#6699FF' },
    totalPaymentNum: {
      key: 'totalPaymentNum',
      text: '总付款人数',
      prompt: '统计时间内对该店铺商品有付款行为的用户总数',
      background: '#52CCA3',
    },
    oderConversionRate: { key: 'oderConversionRate', text: '下单转化率', prompt: '下单人数/实际发送人数', background: '#9580FF' },
    ROI: { key: 'ROI', text: 'ROI', prompt: '付款总金额/（实际短信发送量*每条短信成本）', background: '#657180' },
  };

  /** 生命周期函数/监听函数 */
  useEffect(() => {
    init();
  }, [props]);

  /** 初始化函数     */
  const init = (): void => {
    let crowdPeople_hjy = store.get('crowdPeople_hjy');
    // 页面异常拦截
    if (crowdPeople_hjy === undefined) {
      crowdPeople_hjy = JSON.parse(localStorage.getItem('crowdPeople_hjy') as string);
      if (crowdPeople_hjy === null) {
        // 这里给出提示
        LzMsg.error('系统异常，请返回上一页重新进入', '异常');
      }
    }
    setParams(crowdPeople_hjy || params);
    getPageData();
    setBreadcrumb();
    setLoadingForList(true);
  };

  /** 设置Header面包屑 */
  const setBreadcrumb = (): void => {
    let setName = '';
    let setUrl = '';
    if (localStorage.getItem('tab') === 'tabCrowdMarketing') {
      setName = '官方人群营销';
      setUrl = '/web/crowdMarketing';
    } else if (localStorage.getItem('tab') === 'tabMarketing') {
      setName = '订单筛选营销';
      setUrl = '/web/orderSelection';
    } else if (localStorage.getItem('tab') === 'tabPrivateCrowdMarketing') {
      setName = '云鹿人群营销';
      setUrl = '/web/privateCrowdMarketing';
    }

    /** 设置Header面包屑 */
    utils.setBreadcrumb({
      name: '精准营销', // 一级页面名称
      url: '/web/orderSelection', // 一级页面url
      children: {
        name: setName, // 二级页面名称
        url: setUrl, // 二级页面url
        children: {
          name: '营销效果', // 三级页面名称
          url: '/web/orderSelection/marketingEffect', // 三级页面url
        },
      },
    });
  };

  /**  获取页面列表数据  */
  const getPageData = (searchForm = { pageNo: 1, pageSize: 10, pageNum: 1 }): void => {
    // 获取订单筛选列表数据
    Servlets('getSmsEffectList', { taskId: props.match.params.id })
      .then((res: { data: []; page: { pageNo: number; pageSize: number; total: number } }) => {
        setDataSource(res.data); // 获取列表数据
        setLoadingForList(false);
      })
      .catch((err) => {
        console.log(err);
      });
    Servlets('getSmsEffectDatasummary', { taskId: props.match.params.id })
      .then((res: any) => {
        if (!res.data) {
          setCoreData({
            totalSum: 0,
            totalPaymentNum: 0,
            oderConversionRate: 0,
            ROI: 0,
            perCapitaPaymentNum: 0,
            ordAmount: 0,
            ordPins: 0,
            truePeopleSentNum: 0,
          });
          return;
        }
        const getCoreData = {
          totalSum: (res.data.payAmount / 100).toFixed(2), // 总付款金额
          totalPaymentNum: res.data.payPins, // 总付款人数
          oderConversionRate: res.data.ordPins > 0 ? (res.data.payPins / res.data.ordPins).toFixed(2) : 0, // 下单转化率
          ROI: res.data.roi,
          perCapitaPaymentNum: res.data.ordPins > 0 ? ((res.data.payAmount / 100) / res.data.payPins).toFixed(2) : 0, // 人均付款
          ordAmount: res.data.ordAmount, // 下单金额
          ordPins: res.data.ordPins, // 下单人数（含下单未付款）
          truePeopleSentNum: res.data.truePeopleSentNum, // 短信成功触达人数
        };
        setCoreData({...getCoreData});
        setLoadingForList(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /** 数据导出 */
  const downloadData = () => {
    Servlets('downloadSmsEffectData', { taskId: params.id, taskName: params.name }).then((res: any) => {
      utils.downloadFile(res);
      Message.success('数据已导出');
    });
  };

  const spliceNum = (num) => {
    var num = (num || 0).toString(); let
      result = '';
    while (num.length > 3) {
      result = `,${ num.slice(-3) }${result}`;
      num = num.slice(0, num.length - 3);
    }
    if (num) {
      result = num + result;
    }
    return result;
  };

  return (
    <>
      <section className={style.mainBox}>
        <div className={style.container}>
          <div className={style.pageInfo}>
            <div>
              <p>任务名称：{params.name}</p>
              <p>推送时间：{moment(params.excuteTime).format('YYYY-MM-DD HH:mm:ss')}</p>
              <p>推送人群：{params.packageName}</p>
            </div>
            <div>
              <Button
                type="primary"
                className={style.submitBtnStyle_width}
                onClick={downloadData}
              >数据导出
              </Button>
            </div>
          </div>
          <p className={style.tiggerNum}>短信成功触达人数：<span
            style={{ color: '#00BB66' }}
          >{spliceNum(coreData.truePeopleSentNum)}
          </span>
          </p>

          {/* 核心数据展示 */}
          <div className={style.coreData}>
            {
              Object.values(coreDataLayoutSetting).map((item, index) => {
                return (
                  <div
                    key={index}
                    className={style.dataLayout}
                    style={{ backgroundColor: item.background }}
                  >
                    <p className={style.info}>
                      <Balloon
                        popupClassName="popupClassName"
                        trigger={<span style={{ cursor: 'pointer' }}>{<Icon
                          type="help"
                          size="small"
                          style={{ color: '#fff' }}
                        />}
                                 </span>}
                        closable={false}
                      >
                        {item.prompt}
                      </Balloon>
                    </p>
                    <p className={style.title}>{item.text}</p>
                    <p className={style.num}>{item.key === 'oderConversionRate' ? `${coreData[item.key] * 100 }%` : utils.numFormat_hjy(coreData[item.key])}</p>
                  </div>
                );
              })
            }
            {/* prompt */}
          </div>

          <div className={style.otherData}>
            <p>人均付款（元）：<span style={{ color: 'red' }}>{coreData.perCapitaPaymentNum || 0}</span></p>
            <p>下单人数（含下单未付款）：<span style={{ color: 'red' }}>{coreData.ordPins || 0}</span></p>
          </div>
          <div className={style.listContent}>
            <div style={{ marginTop: 8 }}>
              <Table loading={isLoadingForList} dataSource={dataSource}>
                <Table.Column
                  title="统计日期"
                  key="reportDate"
                  dataIndex="reportDate"
                  cell={(value, index, item) => (<>
                    <span>{moment(value).format('YYYY-MM-DD')}</span>
                  </>)}
                />
                <Table.Column
                  title="下单总人数"
                  key="ordPins"
                  dataIndex="ordPins"
                  cell={(value, index, item) => (<>
                    <span>{utils.numFormat_hjy(value)}</span>
                  </>)}
                />
                <Table.Column
                  title="付款总人数"
                  key="payPins"
                  dataIndex="payPins"
                  cell={(value, index, item) => (<>
                    <span>{utils.numFormat_hjy(value)}</span>
                  </>)}
                />
                <Table.Column
                  title="付款金额（元）"
                  key="payAmount"
                  dataIndex="payAmount"
                  cell={(value, index, item) => (<>
                    <span>{(utils.numFormat_hjy(value) / 100).toFixed(2)}</span>
                  </>)}
                />
              </Table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dialog_MarketingEffect_content;
